import { userDetailsResponse } from '../../types';

interface InitialState {
  userDetails: userDetailsResponse;
  isLogin: boolean;
}

const UpdateLoginAction = 'Login';

export default InitialState;
export { UpdateLoginAction };
